import { render } from "./DashboardViewNew.vue?vue&type=template&id=007f84c4"
import script from "./DashboardViewNew.vue?vue&type=script&lang=js"
export * from "./DashboardViewNew.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__